import { NgxZendeskWebwidgetConfig } from 'ngx-zendesk-webwidget';

export class ZendeskConfig extends NgxZendeskWebwidgetConfig {
    accountUrl = 'frontsystemsnor.zendesk.com';

    callback(zE: any) {
        zE.setLocale('no');
    }
}
